<template>
	<CustomSelectComponent @input="handleInput" :value="value" add-class="mb-3" :options="distanceOption" placeholder="Estimasi jarak anda ke peristiwa" />
</template>

<script>
import {getDistance} from "../../service/LocationService";
import CustomSelectComponent from "./CustomSelectComponent";
import {mapState, mapMutations} from "vuex"

export default {
	name: "SelectDistanceComponent",
	components: {CustomSelectComponent},
  props: {
    value: {
      type: [Number, String],
      default: ''
    }
  },
	async mounted() {
		if (this.distances.length) {
			this.distanceOption = this.distances
		} else {
			let res = await getDistance({})
			this.distanceOption = res.data
			this.setDistances(res.data)
		}
	},
	data() {
		return {
			distanceOption: []
		}
	},
	computed: {
		...mapState('LocationStore', ['distances'])
	},
	methods: {
		...mapMutations('LocationStore', ['setDistances']),
    handleInput(e) {
      this.$emit('input', this.distanceOption.find(item => {
        return String(item.id) === String(e)
      }))
    }
	},
}
</script>
